import React, { useEffect, useState } from "react"
import {
  listActualitesContainer,
  actualitesContainer,
  actualitesDescription,
  listActualitesTitle,
  editButtonTitle,
} from "./actualites.module.scss"
import { Title, ListActualitesContainer } from "./actualites-styled"
import ContentTransformer from "gatsby-theme-blank/src/components/Transformers/content-transformer"
import RenderActualites from "gatsby-theme-blank/src/components/Home/Actualites/RenderActualites/render-actualites"
import { useActualites } from "gatsby-theme-blank/src/components/Home/Actualites/actualites-query"
import { getPublishedData } from "gatsby-theme-blank/src/components/get-published-data"
import EditButton from "gatsby-theme-blank/src/components/EditButton/edit-button"

//-----------------------Parent component---------------------------//

const ListActualites = () => {
  const data = useActualites()
  const [finalData, setFinalData] = useState([])

  useEffect(() => {
    setFinalData(getPublishedData(data.allNodeActualites.edges))
  }, [data])

  if (finalData.length === 0) {
    return null
  }
  return (
    <ListActualitesContainer className={listActualitesContainer}>
      <Title className={listActualitesTitle}>
        <EditButton
          addedClass={editButtonTitle}
          link={
            "/taxonomy/term/" +
            data.taxonomyTermZoneDefinie.drupal_internal__tid +
            "/edit"
          }
        />
        {data.taxonomyTermZoneDefinie?.field_label || "À la une"}
      </Title>
      {data.taxonomyTermZoneDefinie.description && (
        <div className={actualitesDescription}>
          <ContentTransformer
            content={data.taxonomyTermZoneDefinie.description.processed}
          ></ContentTransformer>
        </div>
      )}
      <div className={actualitesContainer}>
        <RenderActualites actualiteData={finalData} />
      </div>
    </ListActualitesContainer>
  )
}

//-----------------------Parent component---------------------------//

export default ListActualites
